module.exports = __webpack_public_path__ + "img/album07_03.076bc31a.jpg";